import { render } from "./VehicleFront.vue?vue&type=template&id=80c65ebc"
import script from "./VehicleFront.vue?vue&type=script&lang=js"
export * from "./VehicleFront.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__